import Qs from 'qs';
import { API_ADDRESS } from '../address';

export function getEndPointPath(path, query) {
    if (query) {
        const params = Qs.stringify(query.getQueryData(), { arrayFormat: 'indices' });
        return `${API_ADDRESS}/${path}?${params}`;
    }
    return `${API_ADDRESS}/${path}`;
}

export function attachToken(api, accessToken) {
    api.defaults.headers.common.Authorization = accessToken;
}
